<template>
  <b-container>
    <b-row v-if="showSubBox">
      <b-col>
        <subscribe-box></subscribe-box>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <network-list :networks="networks" :regions="regions" />
      </b-col>
    </b-row>
    <router-view></router-view>
  </b-container>
</template>

<script type="text/javascript">
import { mapGetters, mapActions } from 'vuex'
import { SubscribeBox, NetworkList } from '@/components'

export default {
  name: 'Dashboard',
  components: { SubscribeBox, NetworkList },
  computed: {
    ...mapGetters(['networks', 'regions', 'userLoggedIn', 'showSubBox'])
  },
  methods: {
    ...mapActions(['fetchNetworks', 'fetchRegions'])
  },
  mounted() {
    Promise.all([this.fetchNetworks(), this.fetchRegions()])
  }
}
</script>
